class MessageController {

  /* @ngInject */
  constructor (users, message, Message, $rootScope, $scope, $mdToast, $mdDialog) {
    this.$rootScope = $rootScope
    this.$scope = $scope
    this.$mdToast = $mdToast
    this.$mdDialog = $mdDialog

    this.Message = Message
    this.users = users

    this.message = message
  }

  cancel () {
    this.$mdDialog.cancel()
  }

  sendMessage () {
    this.$rootScope.$broadcast('payroll:loading:start')
    this.sending = true

    let userIds = []
    let messages = []

    this.users.forEach(user => {
      userIds.push(user.id)
      messages.push(this.message)
    })

    this.Message.intercomGroup({userIds, messages, fromCompany: false})
      .then((res) => {
        this.$rootScope.$broadcast('payroll:loading:done')
        const message = 'Message sent to ' + this.users.length + (this.users.length == 1 ? ' user' : ' users')
        this.$mdToast.showSimple(message)
        this.$mdDialog.hide()
      }).catch((err) => {
        this.$rootScope.$broadcast('payroll:loading:done')
        this.sending = false
        this.$mdToast.showSimple(err.data.reason)
      })
  }
}

export default MessageController
